export function ScheduleCard() {
  return (
    <article className="schedule-card">
      <section>
        <h3 className="schedule-title">Schedules</h3>
        <p className="inline-text">Find your class & session details here</p>
      </section>
      <aside>
        {/* src/pages/home/interactive-lesson-card/images/schedule.svg */}
        <img src="/schedule.svg" alt="Pluritongues Schedule" />
      </aside>
    </article>
  );
}
